/** Formato en español de Honduras. Moneda configurable (por defecto L, lempiras). */
import { isoFromSerial } from '@redmil/shared';

export const CURRENCY = (import.meta.env.VITE_CURRENCY as string | undefined) ?? 'L';

const int = new Intl.NumberFormat('es-HN', { maximumFractionDigits: 0 });
const dec = new Intl.NumberFormat('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const pct = new Intl.NumberFormat('es-HN', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 });

export function formatValue(v: unknown, format: 'percent' | 'money' | 'int'): string {
  if (v === '' || v === null || v === undefined) return '—';
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  if (format === 'percent') return pct.format(n);
  if (format === 'money') return `${CURRENCY} ${dec.format(n)}`;
  return int.format(n);
}

export function formatDate(serial: unknown): string {
  if (typeof serial !== 'number') return '';
  const [y, m, d] = isoFromSerial(serial).split('-');
  return `${d}/${m}/${y}`;
}

export function ago(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return `hace ${s} s`;
  const m = Math.round(s / 60);
  if (m < 60) return `hace ${m} min`;
  return `hace ${Math.round(m / 60)} h`;
}
